<div
  class="flex flex-col justify-center align-middle text-gray-900 !items-stretch"
  [attr.data-testid]="'login-form-container'"
>
  <div
    class="mb-4 mt-6 h-12 w-full text-center"
    [attr.data-testid]="'login-logo-container'"
  >
    <img
      class="inline-block max-h-10"
      src="assets/gosu.png"
      [attr.data-testid]="'login-logo'"
    />
  </div>

  <div
    class="mb-6 text-center text-gray"
    i18n
    [attr.data-testid]="'login-description'"
  >
    登入 {{ serviceName }} 帳戶，開始使用服務
  </div>

  <form
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    class="flex w-full flex-col !items-stretch"
    [attr.data-testid]="'login-form'"
  >
    <mat-form-field
      floatLabel="always"
      class="tight mb-3"
      [attr.data-testid]="'email-field'"
    >
      <mat-label i18n [attr.data-testid]="'email-label'"
        >帳號（Email）</mat-label
      >
      <input
        matInput
        formControlName="email"
        autocomplete="email"
        (blur)="updateEmailAndPasswordValidity()"
        [attr.data-testid]="'email-input'"
      />
      <mat-error [attr.data-testid]="'email-error'">
        <gosu-form-error [control]="email"></gosu-form-error>
      </mat-error>
    </mat-form-field>

    <mat-form-field
      floatLabel="always"
      class="tight"
      [attr.data-testid]="'password-field'"
    >
      <mat-label i18n [attr.data-testid]="'password-label'">密碼</mat-label>
      <input
        matInput
        type="password"
        formControlName="password"
        autocomplete="current-password"
        (blur)="updateEmailAndPasswordValidity()"
        (keydown.enter)="onSubmit()"
        [attr.data-testid]="'password-input'"
      />
      <mat-error [attr.data-testid]="'password-error'">
        <gosu-form-error [control]="password"></gosu-form-error>
      </mat-error>
    </mat-form-field>

    <div
      class="mb-3 text-right"
      [attr.data-testid]="'forgot-password-container'"
    >
      <button
        mat-button
        class="!font-normal"
        color="primary"
        type="button"
        routerLink="../forgot-password"
        tabindex="-1"
        i18n
        [attr.data-testid]="'forgot-password-button'"
      >
        忘記密碼?
      </button>
    </div>

    <button
      mat-flat-button
      color="primary"
      type="submit"
      class="mb-6 !h-12 w-full text-sm"
      [disabled]="!form.valid"
      i18n
      [attr.data-testid]="'login-submit'"
    >
      登入
    </button>

    <div
      class="mb-6 text-center leading-9 text-gray"
      [attr.data-testid]="'register-container'"
    >
      <span i18n>還不是會員嗎？</span
      ><button
        mat-button
        class="!align-top !text-base !font-normal"
        type="button"
        color="primary"
        routerLink="../register"
        i18n
        [attr.data-testid]="'register-button'"
      >
        立即註冊
      </button>
    </div>
  </form>

  @if (enableThirdPartyLogin) {
  <div class="mb-6 flex flex-nowrap" [attr.data-testid]="'third-party-divider'">
    <div class="my-3 flex-1 border-t border-solid border-t-gray-300"></div>
    <p class="px-4 text-gray-60" i18n>或</p>
    <div class="my-3 flex-1 border-t border-solid border-t-gray-300"></div>
  </div>

  <div
    class="mb-6 flex w-full flex-col gap-3 lg:w-[400px]"
    [attr.data-testid]="'third-party-login-container'"
  >
    <gosu-sns
      class="w-full"
      type="LINE"
      mode="LOGIN"
      [attr.data-testid]="'line-login'"
    >
    </gosu-sns>
    <gosu-sns
      class="w-full"
      type="Facebook"
      mode="LOGIN"
      [attr.data-testid]="'facebook-login'"
    >
    </gosu-sns>
    <gosu-sns
      class="w-full"
      type="Google"
      mode="LOGIN"
      [attr.data-testid]="'google-login'"
    >
    </gosu-sns>
  </div>

  <ng-template #tmpFB0002>
    <div
      class="tmp-fb-0002 error-dialog"
      [attr.data-testid]="'facebook-error-dialog'"
    >
      <div class="mat-h2">哎呀，發生了一些小小的狀況</div>
      該電子郵件已經註冊成為 {{ name || "GOSU BAR" }} 的會員， <br />
      但尚未綁定 Facebook 帳戶。 <br />
      所以目前無法透過 Facebook 登入， <br />
      麻煩請先透過帳號密碼登入，並在個人資料管理頁面綁定 Facebook。 <br />
      之後就可以透過 Facebook 登入 {{ name || "GOSU BAR" }} <br />
      <br />
      <button
        mat-raised-button
        color="primary"
        (click)="matConnectedDialog.closeAll()"
        [attr.data-testid]="'facebook-error-close'"
      >
        立即透過帳號密碼登入
      </button>
    </div>

    <ng-template #tmpG0002>
      <div
        class="tmp-g-0002 error-dialog"
        [attr.data-testid]="'google-error-dialog'"
      >
        <div class="mat-h2">哎呀，發生了一些小小的狀況</div>
        該電子郵件已經註冊成為 {{ name || "GOSU BAR" }} 的會員， <br />
        但尚未綁定 Google 帳戶。 <br />
        所以目前無法透過 Google 登入， <br />
        麻煩請先透過帳號密碼登入，並在個人資料管理頁面綁定 Google <br />
        之後就可以透過 Google 登入 {{ name || "GOSU BAR" }} <br />
        <br />
        <button
          mat-raised-button
          color="primary"
          (click)="matConnectedDialog.closeAll()"
          [attr.data-testid]="'google-error-close'"
        >
          立即透過帳號密碼登入
        </button>
      </div>
    </ng-template>
  </ng-template>
  }

  <div
    class="text-center text-[12px] leading-5 text-gray"
    i18n
    [attr.data-testid]="'terms-container'"
  >
    我們將使用您的電子郵件信箱作為聯絡用途 <br />
    登入表示您同意
    <a
      href="https://www.gosu.world/34353"
      target="_new"
      class="text-primary"
      [attr.data-testid]="'terms-of-service'"
    >
      使用條款
    </a>
    、
    <a
      href="https://www.gosu.world/34360"
      target="_new"
      class="text-primary"
      [attr.data-testid]="'security-policy'"
    >
      資訊安全政策
    </a>
    、
    <a
      href="https://www.gosu.world/34359"
      target="_new"
      class="text-primary"
      [attr.data-testid]="'privacy-policy'"
    >
      隱私權政策
    </a>
    。
  </div>
</div>
